import PropTypes from "prop-types";
import React from "react";

const TagsList = (props) => {
  const { Component, tags = [], ...others } = props;

  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }

  return tags.map((tag) => (
    <li key={tag}>
      <Component tag={tag} {...others} />
    </li>
  ));
};

TagsList.propTypes = {
  Component: PropTypes.elementType.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
};

export default TagsList;
